import type { LucideIcon } from 'lucide-react';
import { WelcomeBanner, type BannerTone } from './WelcomeBanner';

export interface HeroStat {
  label: string;
  /** Already formatted by the caller — money via formatINR, quantities via the
   *  Indian-grouped numeral. The tile never re-formats a figure. */
  value: string;
  sub: string;
  icon?: LucideIcon;
  tone?: BannerTone;
}

/**
 * Dashboard header for the role dashboards — now the shared WelcomeBanner
 * (2026-10-23), so every dashboard opens the same way: whose desk, which day,
 * the headline figures in a large type, and Apply for Leave in a fixed place.
 * The props are unchanged, so no caller had to move.
 */
export function DashboardHero({
  badge,
  badgeIcon: _badgeIcon,
  title,
  subtitle,
  heroStats,
}: {
  badge: string;
  badgeIcon: LucideIcon;
  title: string;
  subtitle: string;
  heroStats: HeroStat[];
}) {
  const today = new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' });
  return (
    <WelcomeBanner
      eyebrow={`${badge} · ${today}`}
      title={title}
      subtitle={subtitle}
      stats={heroStats.map((h) => ({ label: h.label, value: h.value, sub: h.sub || undefined, icon: h.icon, tone: h.tone }))}
    />
  );
}
